<div class="form-row">
  <div class="alert alert-{{colorErreur}} col-12" *ngIf="rootForm.errors && rootForm.errors[labelErreur] && !(modeRendu.enModeImpression$ | async)">
    <div class="text-center align-middle">
      {{ erreursMap.get(labelErreur) }}
    </div>
  </div>
</div>